import { classes } from 'html-classes';
import { forwardRef } from 'react';

import Icon from '~/components/Icon/Icon';
import { IconTypes } from '~/components/Icon/IconTypes';
import Spinner from '~/components/isolated/Spinner';

import styles from './Button.module.scss';
import { IconSizeMap, SIZE, SizeMap, VARIANT, VariantMap } from './constants';
import { ButtonProps } from './interfaces';

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = VARIANT.primary,
      size = SIZE.M,
      type = 'button',
      className,
      children,
      startIcon,
      disabled,
      endIcon,
      iconSize: iconSizeProp,
      isLoading,
      ...props
    },
    ref,
  ) => {
    const iconSize = iconSizeProp ?? IconSizeMap.get(size);
    const spinnerVariant =
      variant === VARIANT.primary || variant === VARIANT.brand
        ? 'white'
        : 'default';

    return (
      <button
        {...props}
        ref={ref}
        className={classes([
          styles.button,
          VariantMap.get(variant),
          SizeMap.get(size),
          className,
        ])}
        disabled={disabled || isLoading}
        type={type}
      >
        {isLoading ? (
          <Spinner variant={spinnerVariant} />
        ) : (
          <>
            {typeof startIcon === 'string' ? (
              <Icon type={startIcon as IconTypes} size={iconSize} />
            ) : (
              startIcon
            )}
            {children}
            {typeof endIcon === 'string' ? (
              <Icon type={endIcon as IconTypes} size={iconSize} />
            ) : (
              endIcon
            )}
          </>
        )}
      </button>
    );
  },
);

Button.displayName = 'Button';

export default Button;
